<template>
  <div id="app">
    <div v-if="layout === 'common'">
      <Header />
    </div>
    <div :id="layout + '_layout_wrapper'">
      <router-view />
    </div>
  </div>
</template>

<style lang="scss">
body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol", "Noto Color Emoji";
  margin: 0 0 50px;
  background: #f5f5f5;
}
#common_layout_wrapper {
  width: 1200px;
  margin: 0 auto;
  .el-card {
    border: 0;
    border-radius: 10px;
    box-shadow: none;
  }
  .el-card__header {
    border-bottom: 0;
    padding-bottom: 0;
    font-size: 18px;
    font-weight: 400;
  }
  .el-checkbox__inner {
    border-color: #409eff;
  }
}
.el-popover .el-checkbox__inner {
  border-color: #409eff;
}
#login_layout_wrapper {
  width: 600px;
  margin: 30px auto;
  .el-card {
    border: 0;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.03);
  }
  .el-card__header {
    border-bottom: 0;
    padding-bottom: 0;
    font-size: 18px;
    font-weight: 400;
  }
}
.pager {
  .el-pagination {
    padding: 0;
  }
  text-align: center;
  margin-top: 20px;
}
</style>

<script>
import Header from "./components/Header.vue";
export default {
  data() {
    return {
      layout: "common",
    };
  },
  components: {
    Header,
  },
};
</script>
